import styled from 'styled-components';

export const LargeBlockQuoteContainer = styled.div`
  display: grid;
  row-gap: 1.5rem;
  padding-bottom: 2.5rem;
`;

export const LargeBlockQuoteAuthor = styled.div`
  display: grid;
  grid-template-columns: 66px 1fr;
  column-gap: 1rem;
`;

export const LargeBlockQuoteAvatar = styled.div`
  align-self: center;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  overflow: hidden;
`;

export const LargeBlockQuoteAuthorText = styled.div`
  align-self: center;
`;
